// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","tablet":"(max-width: 1024px)","wrapper":"wrapper-3mZYO","title":"title-dgSkx"};